<template>
    <div
        class="w-full h-full flex flex-col justify-center bg-neutral-0 text-base tracking-normal rounded-b-xl" 
    >
        <div class="flex justify-between items-center w-full px-4 py-3 bg-neutral-1 border-b border-neutral-2">
            <div>
                <DropboxSVG />
            </div>
            <div class="" >
                <button @click.prevent="dropboxIconClicked"
                    class="rounded-md px-2 py-1 text-white bg-dark-primary hover:bg-dark-secondary"
                >
                    Open Dropbox
                </button>
            </div>
        </div>
        <div class="overflow-y-scroll p-5 w-full h-full bg-neutral-0">
            <div v-if="tempAttachments.length > 0" class="w-full grid grid-cols-4 space-x-4">
                <DropboxFileThumbnail 
                    v-for="tempAttachment of tempAttachments" 
                    :key="tempAttachment._id"
                    :file="tempAttachment"
                    @remove-file="removeAttachment" 
                />
            </div>
            <div v-else
                class="flex h-full w-full justify-center items-center text-neutral-5 tracking-widest"
            >
                No Files Attached
            </div>
        </div>
        <div class="flex w-full justify-center py-3 border-t bg-neutral-1 border-neutral-2 rounded-b-xl">
            <button @click.prevent="uploadAttachments"
            class="rounded-lg px-2 py-1  flex space-x-1 text-white justify-center items-center bg-dark-primary hover:bg-dark-secondary"
            >
                Upload Files
            </button>
        </div>
        <component
            src="https://www.dropbox.com/static/api/2/dropins.js"
            :is="'script'"
            id="dropboxjs"
            data-app-key="xt3cyly9ie4ck3c"
        >
        </component>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, onMounted} from 'vue';
import DropboxSVG from '../svg-components/DropboxSVG.vue';
import DropboxFileThumbnail from '@/components/base-components/DropboxFileThumbnail.vue';
const emit = defineEmits(['upload-dropbox-files'])


// onMounted(() => {
//     let dropbox = document.createElement("script");
//     dropbox.setAttribute(
//         "src",
//         "https://www.dropbox.com/static/api/2/dropins.js"
//     );
//     dropbox.setAttribute('id', 'dropboxjs')
//     dropbox.setAttribute('data-app-key', 'qm8lh74d1y79ws')
//     document.head.appendChild(dropbox)
// })

const tempAttachments = ref([])

function dropboxIconClicked() {
 let options = {
  success: async files => {
   let attachments = [];
   for (let i = 0; i < files.length; i++) {
    let attachment = {};
    attachment._id = files[i].id;
    attachment.title = files[i].name;
    attachment.size = files[i].bytes;
    attachment.iconURL = files[i].icon;
    attachment.link = files[i].link;
    attachment.extension = `. ${files[i].name.split(".")[1]}`;
    attachments.push(attachment);
   }
   tempAttachments.value = attachments;
   console.log(tempAttachments.value);
  },

  cancel: function() {},

  linkType: "preview",

  multiselect: true,

  extensions: [
   ".pdf",
   ".doc",
   ".docx",
   ".png",
   ".jpg",
   ".ppt",
   ".pptx",
   ".xls"
  ],

  folderselect: false,

  sizeLimit: 102400000
 };
 // eslint-disable-next-line no-undef
 Dropbox.choose(options);
}

function uploadAttachments() {
    emit('upload-dropbox-files', tempAttachments.value)
}

function removeAttachment(attachmentId) {
    const attachmentIndex = tempAttachments.value.findIndex((attachment) => attachment._id == attachmentId)
    if(attachmentIndex != -1) {
        tempAttachments.value.splice(attachmentIndex, 1)
    }
}

</script>